/**
 * @author Sumit Majumdar
 * @email sumit@grexit.com
 * @create date 2018-04-02 03:48:30
 * @modify date 2018-04-02 03:48:30
 * @desc [description]
*/
import { UPDATE_SM_DONE, UPDATE_SM_INIT, UPDATE_SM_FAILED } from '../../common/actions';
import { HiverAxios, showMessage, sendTrackingEvent } from 'h-commons'
import { snackbarMessages } from '../resources';

const SM_ROOT = '/sharedmailbox';
/**
 * @param  {Object}     sm          - sharedmailbox 
 * @param  {string}     settingName - setting name
 * @param  {boolean}    enabled     - state for the setting 
 * @param  {boolean}    isTest      - used for unit testing
 */
export const toggleSMAdvancedSetting = (sm, settingName, enabled, isTest) => 
    dispatch => {
        const url = `${SM_ROOT}/${sm.id}/smAdvanceSettings?setting=${settingName}&enabled=${enabled}`;
        dispatch({
            type: UPDATE_SM_INIT
        });
        return new Promise((resolve, reject) => {
            HiverAxios({
                url,
                type: 'POST',
                params: {},
                callback: response => {
                    const success = response.data ? response.data.status === 'success' : false;
                    if (success) {
                        const sm_adv_settings = sm.sm_adv_settings
                                .map(({id, status}) => ({
                                    id,
                                    status: id === settingName ? enabled : status
                                }));

                        dispatch({
                            type: UPDATE_SM_DONE,
                            payload: { ...sm, sm_adv_settings }
                        });
                        const settingSnackBar = snackbarMessages[settingName];
                        const smName = sm.display_name;
                        showMessage({message: settingSnackBar ? ( enabled ? settingSnackBar.success(smName) : settingSnackBar.failed(smName)) : response.data.message,type:'success'});
                        settingName === 'csat' ? sendTrackingEvent(enabled ? 'enabledCSAT' : 'disabledCSAT') : '';
                        settingName === 'auto_assign_on_reply'  && sendTrackingEvent(enabled ? 'autoSelfAssignOn' : 'autoSelfAssignOff');
                    } else {
                        dispatch({
                            type: UPDATE_SM_FAILED
                        });
                        const message = response.data.message || 'Failed to enable advanced setting';
                        showMessage({message,type:'error'});
                    }
                    resolve(response.data);
                },
                onfail: function(err){
                    const message = err.response && err.response.data && err.response.data.message 
                                ? err.response.data.message : `Failed to enable advanced setting`;
                    dispatch({
                        type: UPDATE_SM_FAILED
                    });
                    showMessage({message,type:'error'});
                    reject(err);
                }
            }, isTest);
        })
    };
